import { createTestIds } from '../../utils';
import { elements } from '../FormField/FormField.test-ids';

export const getRadioCheckTestIds = createTestIds('radio-check', ['control', ...elements] as const);
